import { createContext } from 'react';

import { OwnerQueryKeysContextProps } from './OwnerQueryKeysContext.type';

export const OwnerQueryKeysContext = createContext<OwnerQueryKeysContextProps | undefined>(undefined);
